import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Box, Container, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import ImportCufXml from './components/ImportCufXml';
import { formatDate, getLocalStorageItem, setLocalStorageItem } from '../../../_helpers';
import axios from 'axios';
import DataGridV2 from '../../../components/DataGridV2';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../../_constants';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { INITIAL_ROW_SELECTION_MODEL } from '../../../components/DataGridV2/constants';
import { useSelector } from 'react-redux';
import { Add } from '@mui/icons-material';
import { getCufXmlImportColumns } from './utils';

export default function ImportCufXmlList() {
    const classes = useStyles();
    const apiRef = useGridApiRef();
    const { t , i18n } = useTranslation();
    const [openImport, setOpenImport] = useState(false);
    const [importCufXmlList, setImportCufXmlList] = useState([])
    const { webApiUrl } = window.appConfig;
    const app = useSelector((state) => state.app);
    const [loading, setLoading] = useState({ getCufXmlList: false })
    const keyPrefix = app === apps.settingModule ? "SETTING" : "GENERAL";
    const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
    const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
        LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_PAGINATION[keyPrefix], undefined
    ))
      
    useEffect(() => {
        updateList();
    }, [])

    const updateList = () => {
        setLoading(p => ({ ...p, getCufXmlList: true }))
        const url = webApiUrl + 'api/ImportExport/GetCufXmlList';
        axios.get(url)
            .then(response => {
                setImportCufXmlList(response.data)
                setLoading(p => ({ ...p, getCufXmlList: false }))
            })
            .catch(error => {
                setLoading(p => ({ ...p, getCufXmlList: false }))
            });
    }
     const columns = getCufXmlImportColumns({t,keyPrefix,i18n,apiRef})
     
    const getToolbarProps = useMemo(() => {
    
        return {
          toolbarStartActions: [
            {
              title: t("general.add"),
              icon: Add,
              onClick: () => setOpenImport(true) 
            },
          ],
          title:t('settings.importCufXml.title')
        };
      }, [t]);

    const onPaginationModelChange = useCallback((newPaginationModel) => {
        setPaginationModel(newPaginationModel)
        setLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_PAGINATION[keyPrefix],
          newPaginationModel
        );
      }, [keyPrefix])

      const getCufXmlImportsListForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
          const userSelectedRows = isAllSelected ? importCufXmlList : idsToExport.map(id => importCufXmlList?.find(item => item?.id === id));
             const results = userSelectedRows?.map((item) => {
                      let result = {}
                      Object.keys(item).forEach((key) => {
                          let value = item[key];
                          const isDateTimeField = columns.some(x => x.field === key && x.type === 'dateTime');
                          if (isDateTimeField) {
                            value = item[key] ? formatDate(new Date(item[key]), true, "-", false) : "";
                           } 
                          result[key] = value;
                        });
                      return result
                  })
          return results;
        };

      return (
        <Container maxWidth={false} elevation={0} className={classes.mainContainer}>
            <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
            <Box p={2} >
                <Typography className={classes.headerTitle} variant='h6'>{t("settings.importCufXml.title")}</Typography>
            </Box>
            <Box sx={{flex:1,minHeight:0}}>
            <DataGridV2
                localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_SEARCH_TEXT[keyPrefix]}
                localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_FILTER[keyPrefix]}
                localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_SORT[keyPrefix]}
                localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_ORDER[keyPrefix]}
                localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_WIDTH[keyPrefix]}
                localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_VISIBILITY[keyPrefix]}
                apiRef={apiRef}
                checkboxSelection
                loading={loading.getCufXmlList}
                rows={importCufXmlList ? importCufXmlList : []}
                columns={columns}
                pagination
                filterMode="client"
                {...(!!paginationModel && { paginationModel })}
                onPaginationModelChange={onPaginationModelChange}
                rowSelectionModel={rowSelectionModel}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel);
                }}
                toolbarProps={{
                    ...getToolbarProps,
                    selectedRows: rowSelectionModel,
                    getData: getCufXmlImportsListForPrintAndDownload
                }}
            />
            </Box>
            </Box>
             <ImportCufXml
                canOpen={openImport}
                onClose={(refresh) => {
                    setOpenImport(false);
                    if (refresh) updateList();
                }}
            />
        </Container>
    )
}


const useStyles = makeStyles((theme) => ({
    '@global': {
        '.MuiButtonBase-root:focus': {
            outline: 0,
        },
    },
    mainContainer: {
        height: '100%',
        width: '100%',
        overflow: 'auto',
        padding: theme.spacing(0),
        background: theme.palette.common.white
    },
}))